const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;
// @components
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');


class ContractPayrollLoanDocumentsLeaveModal extends React.Component {

    buildLeaveModal() {
        const { dropRecord, onConfirmLeave } = this.props;

        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');

        const isReady = () => {
            return false;
        }

        const leaveModalLeftBtnText = {
            text: formatText('payrollLoanRequest-modalLeaveButton'),
            redirect: true,
            callback: dropRecord
        };

        const leaveModalRightButtonConfig = {
            text: formatText('payrollLoanRequest-continueLater'),
            redirect: true
        };

        const leaveModalMessage = formatText('payrollLoanRequest-modalLeaveText');
        const leaveModalTitle = formatText('payrollLoanRequest-modalLeaveTitle');

        return (
            <PreLeaveModalComponent
                isReady={isReady}
                acceptText={acceptText}
                cancelText={cancelText}
                confirmationMessage={leaveModalMessage}
                confirmationTitle={leaveModalTitle}
                leftButtonConfig={leaveModalLeftBtnText}
                rightButtonConfig={leaveModalRightButtonConfig}
                onConfirmLeave={onConfirmLeave}
            />
        );
    }

    render() {
        const leaveModal = this.buildLeaveModal();
        return (
            <div> {leaveModal} </div>
        );
    }
}

ContractPayrollLoanDocumentsLeaveModal.propTypes = {
    dropRecord: PropTypes.func.isRequired,
    onConfirmLeave: PropTypes.func.isRequired,
};

module.exports = ContractPayrollLoanDocumentsLeaveModal;
